





import ApplicationSummary from './components/applicationSummary/ApplicationSummary.vue'
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'index',
  components: {
    ApplicationSummary,
  }
})
export default class extends Vue {
}
